export enum ShareInfoTypeEnum {
    Shareholder = 1,
    Trader = 2
}
